/* DeSiM 公式店 — 商品页B（データ容量型・sections/main-product-data.liquid）専用 JS。
   3 軸選択（使い方タイプ → 容量 → 日数）を variant 1 個に解決する。

   🔴 3 軸のうち「使い方タイプ」と「容量」は 1:1 で紐付く（値そのものが
      "1GB/毎日" のように型を内包している）ので容量ピルは型ごと丸ごと
      表示/非表示を切り替える。一方「日数」は両タイプで値が重なりうる
      （"5日間" は日次リセットにも総量にも存在しうる）ので、日数ピルは
      非表示にせず disabled で残す（brief 指示のとおり）。

   🔴 variant の実体（id・価格・容量/日数の生値）は隠し
      `[data-ds-variant-catalog]` 配下の 1 variant = 1 要素（data-* 属性のみ、
      JSON blob 化しない）から都度引く——単一ピルに単一 variant を载せられる
      商品页A（無制限型・1軸）と違い、3 軸だと「今クリックされたピル」だけでは
      variant を一意に決められないため、必ず現在の3値で catalog を検索する
      設計にしている。 */
(function () {
  var form = document.querySelector('[data-ds-product-form]');
  if (!form) return;

  var variantInput = form.querySelector('[data-ds-variant-input]');
  var typeButtons = Array.prototype.slice.call(form.querySelectorAll('[data-ds-type-card]'));
  var capacityGroups = Array.prototype.slice.call(
    form.querySelectorAll('[data-ds-capacity-group]'),
  );
  var dayPills = Array.prototype.slice.call(form.querySelectorAll('[data-ds-day-pill]'));
  var dayOtherSelect = form.querySelector('[data-ds-day-other]');
  var dayOtherWrap = dayOtherSelect ? dayOtherSelect.closest('.ds-day-other') : null;
  var catalogEls = Array.prototype.slice.call(
    form.querySelectorAll('[data-ds-variant-catalog] [data-variant-id]'),
  );

  var priceLabelEls = document.querySelectorAll('[data-ds-price-days]');
  var priceValueEls = document.querySelectorAll('[data-ds-price-value]');
  var perDayEls = document.querySelectorAll('[data-ds-per-day]');
  var perDayNoteEls = document.querySelectorAll('[data-ds-per-day-note]');
  var stickyDaysEls = document.querySelectorAll('[data-ds-sticky-days]');
  var stickyValueEls = document.querySelectorAll('[data-ds-sticky-value]');
  var step2HeadingEls = document.querySelectorAll('[data-ds-step2-heading]');

  var noteDailyPrefix = form.getAttribute('data-note-daily-prefix') || '毎日';
  var noteDailySuffix = form.getAttribute('data-note-daily-suffix') || 'にリセット';
  var noteTotalPrefix = form.getAttribute('data-note-total-prefix') || '期間内で合計';
  var noteTotalSuffix = form.getAttribute('data-note-total-suffix') || 'まで';

  var state = { type: null, capacity: null, days: null };

  function formatYen(cents) {
    var yen = Math.round(Number(cents) / 100);
    return '¥' + yen.toLocaleString('ja-JP');
  }

  function setText(nodeList, text) {
    for (var i = 0; i < nodeList.length; i++) nodeList[i].textContent = text;
  }

  function findCatalogEntry(type, capacity, days) {
    for (var i = 0; i < catalogEls.length; i++) {
      var el = catalogEls[i];
      if (
        el.getAttribute('data-type') === type &&
        el.getAttribute('data-capacity') === capacity &&
        el.getAttribute('data-days') === days
      ) {
        return el;
      }
    }
    return null;
  }

  function comboExists(type, capacity, days) {
    return !!findCatalogEntry(type, capacity, days);
  }

  function availableDaysFor(type, capacity) {
    var found = [];
    for (var i = 0; i < catalogEls.length; i++) {
      var el = catalogEls[i];
      if (el.getAttribute('data-type') === type && el.getAttribute('data-capacity') === capacity) {
        found.push(el.getAttribute('data-days'));
      }
    }
    return found;
  }

  // 🔴 day_list は商品全体（全 type × 全 capacity）の和集合なので、
  //    "その他の日数" セレクトは今の (type, capacity) には存在しない日数を
  //    平気で提示してくる。選ばれた日数がそのままでは resolveVariant() が
  //    無言で no-op するので、現在の (type, capacity) 内で数値的に一番近い
  //    日数へ丸める——見た目の選択と実際に解決される variant を絶対に
  //    乖離させない。
  function nearestAvailableDay(type, capacity, targetDays) {
    var available = availableDaysFor(type, capacity);
    if (!available.length) return null;
    var targetNum = parseInt(targetDays, 10);
    var best = available[0];
    var bestDiff = Math.abs(parseInt(best, 10) - targetNum);
    for (var i = 1; i < available.length; i++) {
      var diff = Math.abs(parseInt(available[i], 10) - targetNum);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = available[i];
      }
    }
    return best;
  }

  function capacityGroupFor(type) {
    for (var i = 0; i < capacityGroups.length; i++) {
      if (capacityGroups[i].getAttribute('data-type') === type) return capacityGroups[i];
    }
    return null;
  }

  function selectType(type) {
    state.type = type;
    typeButtons.forEach(function (btn) {
      var match = btn.getAttribute('data-type') === type;
      btn.classList.toggle('is-selected', match);
      btn.setAttribute('aria-pressed', match ? 'true' : 'false');
      if (match) {
        var heading = btn.getAttribute('data-step2-heading');
        if (heading) setText(step2HeadingEls, heading);
      }
    });
    capacityGroups.forEach(function (group) {
      group.hidden = group.getAttribute('data-type') !== type;
    });

    var group = capacityGroupFor(type);
    if (!group) return;
    var pills = Array.prototype.slice.call(group.querySelectorAll('[data-ds-capacity-pill]'));
    var current = pills.filter(function (p) {
      return p.classList.contains('is-selected');
    })[0];
    if (!current) current = pills[0];
    selectCapacity(current);
  }

  function selectCapacity(el) {
    if (!el) return;
    var group = el.closest('[data-ds-capacity-group]');
    Array.prototype.slice
      .call(group.querySelectorAll('[data-ds-capacity-pill]'))
      .forEach(function (p) {
        p.classList.toggle('is-selected', p === el);
        p.setAttribute('aria-pressed', p === el ? 'true' : 'false');
      });
    var otherWrap = group.querySelector('.ds-capacity-other');
    if (otherWrap) otherWrap.classList.remove('is-selected');
    var otherSelect = group.querySelector('[data-ds-capacity-other]');
    if (otherSelect) otherSelect.value = '';

    state.capacity = el.getAttribute('data-capacity');
    refreshDayPills();
  }

  function refreshDayPills() {
    var selected = null;
    dayPills.forEach(function (pill) {
      var days = pill.getAttribute('data-days');
      var available = comboExists(state.type, state.capacity, days);
      pill.disabled = !available;
      pill.setAttribute('aria-disabled', available ? 'false' : 'true');
      if (!available && pill.classList.contains('is-selected')) {
        pill.classList.remove('is-selected');
        pill.setAttribute('aria-pressed', 'false');
      }
      if (available && pill.classList.contains('is-selected')) selected = pill;
    });

    if (!selected) {
      selected = dayPills.filter(function (pill) {
        return comboExists(state.type, state.capacity, pill.getAttribute('data-days'));
      })[0];
    }

    if (selected) {
      if (dayOtherSelect) dayOtherSelect.value = '';
      if (dayOtherWrap) dayOtherWrap.classList.remove('is-selected');
      selectDay(selected);
    }
  }

  function selectDay(el) {
    if (!el) return;
    dayPills.forEach(function (p) {
      p.classList.toggle('is-selected', p === el);
      p.setAttribute('aria-pressed', p === el ? 'true' : 'false');
    });
    state.days = el.getAttribute('data-days');
    resolveVariant();
  }

  function resolveVariant() {
    var entry = findCatalogEntry(state.type, state.capacity, state.days);
    if (!entry) return;

    var id = entry.getAttribute('data-variant-id');
    var price = entry.getAttribute('data-price');
    var capacityBase = entry.getAttribute('data-capacity-base');
    var daysNum = entry.getAttribute('data-days-num');

    if (variantInput) variantInput.value = id;

    var label = state.capacity + ' × ' + state.days;
    setText(priceLabelEls, label);
    setText(priceValueEls, formatYen(price));
    setText(stickyDaysEls, label);
    setText(stickyValueEls, formatYen(price));

    if (perDayEls.length && daysNum) {
      var perDay = Math.floor(Number(price) / 100 / Number(daysNum));
      setText(perDayEls, '¥' + perDay.toLocaleString('ja-JP'));
    }

    if (perDayNoteEls.length) {
      var note =
        state.type === '総量'
          ? noteTotalPrefix + capacityBase + noteTotalSuffix
          : noteDailyPrefix + capacityBase + noteDailySuffix;
      setText(perDayNoteEls, note);
    }
  }

  typeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      selectType(btn.getAttribute('data-type'));
    });
  });

  capacityGroups.forEach(function (group) {
    Array.prototype.slice
      .call(group.querySelectorAll('[data-ds-capacity-pill]'))
      .forEach(function (pill) {
        pill.addEventListener('click', function () {
          selectCapacity(pill);
        });
      });

    var otherSelect = group.querySelector('[data-ds-capacity-other]');
    if (otherSelect) {
      otherSelect.addEventListener('change', function () {
        var opt = otherSelect.options[otherSelect.selectedIndex];
        if (!opt || !opt.value) return;
        Array.prototype.slice
          .call(group.querySelectorAll('[data-ds-capacity-pill]'))
          .forEach(function (p) {
            p.classList.remove('is-selected');
            p.setAttribute('aria-pressed', 'false');
          });
        var wrap = otherSelect.closest('.ds-capacity-other');
        if (wrap) wrap.classList.add('is-selected');
        state.capacity = opt.value;
        refreshDayPills();
      });
    }
  });

  dayPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      if (dayOtherSelect) dayOtherSelect.value = '';
      if (dayOtherWrap) dayOtherWrap.classList.remove('is-selected');
      selectDay(pill);
    });
  });

  if (dayOtherSelect) {
    dayOtherSelect.addEventListener('change', function () {
      var opt = dayOtherSelect.options[dayOtherSelect.selectedIndex];
      if (!opt || !opt.value) return;
      var picked = opt.value;

      if (!comboExists(state.type, state.capacity, picked)) {
        var fallback = nearestAvailableDay(state.type, state.capacity, picked);
        if (!fallback) {
          // この (使い方タイプ, 容量) には有効な日数が1つも無い —
          // select を元に戻し、見た目の選択が解決済み variant と
          // 食い違ったままにならないようにする。
          dayOtherSelect.value = state.days || '';
          return;
        }
        picked = fallback;
      }

      var fallbackPill = dayPills.filter(function (p) {
        return p.getAttribute('data-days') === picked && !p.disabled;
      })[0];

      if (fallbackPill) {
        // 解決した日数が（overflow バケットではなく）見えているピルの中に
        // 実在する — そちらを選択状態にする。ピル行と <select> が食い違う
        // 表示にならないように。
        dayOtherSelect.value = '';
        if (dayOtherWrap) dayOtherWrap.classList.remove('is-selected');
        selectDay(fallbackPill);
        return;
      }

      dayOtherSelect.value = picked;
      dayPills.forEach(function (p) {
        p.classList.remove('is-selected');
        p.setAttribute('aria-pressed', 'false');
      });
      state.days = picked;
      resolveVariant();
      if (dayOtherWrap) dayOtherWrap.classList.add('is-selected');
    });
  }

  // 初期状態は SSR（Liquid）側で正しく描画済みなので、DOM から state を拾うだけ。
  // 🔴 ただし既定 variant の容量/日数が >7 の overflow バケットにある場合は
  //    どのピルにも .is-selected が付かない（ピル自体が存在しない）ので、
  //    その軸だけは対応する <select>（SSR が正しい <option selected> を
  //    描画済み）から読む。読まないと state が null のまま残り、最初の
  //    ピル操作までずっと price panel / sticky / hidden input が
  //    未解決状態になる。
  (function initState() {
    var selType = typeButtons.filter(function (b) {
      return b.classList.contains('is-selected');
    })[0];
    if (selType) {
      state.type = selType.getAttribute('data-type');
    } else if (!typeButtons.length && capacityGroups.length) {
      // 🔴 単一タイプ商品（使い方タイプが1種類しか無く [data-ds-type-card] が
      //    1枚も描かれない、75商品中41商品）: state.type を決める書き手が
      //    ここまで typeButtons しか無く、type-card が無いと state.type が
      //    null のまま固定されてしまい、comboExists()/findCatalogEntry() が
      //    「type===null」を永遠に false 判定して日数ピルが全部 disabled に
      //    なり、resolveVariant() も早期 return して hidden input が SSR の
      //    既定 variant のまま更新されない（容量/日数ピルの見た目だけ動く）。
      //    容量グループ自身が data-type を保持しているので、唯一の
      //    （非 hidden）グループから type を拾って埋める。
      var onlyGroup =
        capacityGroups.filter(function (g) {
          return !g.hidden;
        })[0] || capacityGroups[0];
      state.type = onlyGroup.getAttribute('data-type');
    }

    var visibleGroup = capacityGroups.filter(function (g) {
      return !g.hidden;
    })[0];
    if (visibleGroup) {
      var selCap = visibleGroup.querySelector('[data-ds-capacity-pill].is-selected');
      if (selCap) {
        state.capacity = selCap.getAttribute('data-capacity');
      } else {
        // 既定 variant の容量が >7 の「その他の容量」overflow バケットに
        // ある場合、どのピルにも .is-selected が付かない — state.capacity を
        // null のまま残さず、<select>（SSR が該当 <option selected> を
        // 描画済み）から読む。
        var capOtherSelect = visibleGroup.querySelector('[data-ds-capacity-other]');
        if (capOtherSelect && capOtherSelect.value) {
          state.capacity = capOtherSelect.value;
          var capOtherWrap = capOtherSelect.closest('.ds-capacity-other');
          if (capOtherWrap) capOtherWrap.classList.add('is-selected');
        }
      }
    }

    var selDay = dayPills.filter(function (p) {
      return p.classList.contains('is-selected');
    })[0];
    if (selDay) {
      state.days = selDay.getAttribute('data-days');
    } else if (dayOtherSelect && dayOtherSelect.value) {
      // 日数軸でも同じ overflow 状況。
      state.days = dayOtherSelect.value;
      if (dayOtherWrap) dayOtherWrap.classList.add('is-selected');
    }
  })();
})();
